export default {"src":"/_next/static/media/loading.64f0b511.gif","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};